import { render, staticRenderFns } from "./LoginUserAvatar.vue?vue&type=template&id=120a368e&scoped=true"
import script from "./LoginUserAvatar.vue?vue&type=script&lang=js"
export * from "./LoginUserAvatar.vue?vue&type=script&lang=js"
import style0 from "./LoginUserAvatar.vue?vue&type=style&index=0&id=120a368e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a368e",
  null
  
)

export default component.exports